'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$002dMode from "./presto.-Login-Page-View$-Mode.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$5(_$ordinal$2, \u03b4name$2, outer) {
  this.cxf = 0;
  this.a8e = null;
  this.cxf = _$ordinal$2;
  this.a8e = \u03b4name$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  $j_presto$002e$002dLogin$002dPage$002dView$0024$002dMode.$ct_Lpresto_LoginPageView$Mode__Lpresto_LoginPageView__(this, outer.b6H);
}
export { $c_Lpresto_LoginPageView$$anon$5 as $c_Lpresto_LoginPageView$$anon$5 };
$p = $c_Lpresto_LoginPageView$$anon$5.prototype = new $j_presto$002e$002dLogin$002dPage$002dView$0024$002dMode.$h_Lpresto_LoginPageView$Mode();
$p.constructor = $c_Lpresto_LoginPageView$$anon$5;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$5() {
}
export { $h_Lpresto_LoginPageView$$anon$5 as $h_Lpresto_LoginPageView$$anon$5 };
$h_Lpresto_LoginPageView$$anon$5.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a8e;
});
$p.l = (function() {
  return this.a8e;
});
var $d_Lpresto_LoginPageView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$5, "presto.LoginPageView$$anon$5", ({
  Ms: 1,
  Mx: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_LoginPageView$$anon$5 as $d_Lpresto_LoginPageView$$anon$5 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$5.js.map
